<template>
	<el-tooltip effect="dark" :content="data.customerGroupTitle" placement="top-start">
		<el-row v-if="data.customerGroup.length">
			<el-col v-for="(item, index) in this.data.customerGroup" :key="item + index">
				<span class="defaultMailbox">{{ item }}</span>
			</el-col>
		</el-row>
		<div v-else>-</div>
	</el-tooltip>
</template>
<script>
export default {
	components: {},
	props: ['scope', 'tableData'],
	data() {
		return {
			typeCard: '',
			showContactCard: false,
		};
	},
	computed: {
		data() {
			let { scope, tableData } = this;
			return {
				customerGroup: scope.row[tableData.bind],
				customerGroupTitle: scope.row[tableData.bind].join(','),
			};
		},
	},
};
</script>
<style lang="scss" scoped>
.defaultMailbox {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: bottom;

  /* 文字超出宽度则显示ellipsis省略号 */
  text-overflow: ellipsis;
  width: 80%;
}
</style>
